import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import type { SelfDescribingJson } from '@snowplow/browser-tracker'

export type CheckoutSessionContextData = comluxgroup.CheckoutSession_1_0_0

export function checkoutSessionContext(data: CheckoutSessionContextData): SelfDescribingJson {
  return comluxgroup.createCheckoutSession_1_0_0(data)
}
